import Matter from 'matter-js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      // AVAILABLE COLORS
      if ( $( '.color-blend-visualizer' ).attr( 'data-type' ) == 'play' ) {
        const sColors = [
          {Id: '200', Label: 'Black', Ral: '9004', Hex: '282828'},
          {Id: '232', Label: 'Terracotta Red', Ral: '3016', Hex: '9C322E'},
          {Id: '236', Label: 'Light Grey', Ral: '7035', Hex: 'CBD0CC'},
          {Id: '239', Label: 'Green', Ral: '6025', Hex: '3E753B'},
          {Id: '240', Label: 'Beige', Ral: '1001', Hex: 'D1BC8A'},
          {Id: '247', Label: 'Blue', Ral: '5017', Hex: '0E518D'},
        ]; const sPlusColors = [
          {Id: '231', Label: 'Bright Green', Ral: '6017', Hex: '468641'},
          {Id: '233', Label: 'Light Green', Ral: '6011', Hex: '68825B'},
          {Id: '235', Label: 'Brown', Ral: '8024', Hex: '9C6B30'},
          {Id: '238', Label: 'Sky Blue', Ral: '5015', Hex: '2874B2'},
          {Id: '243', Label: 'Pearl White', Ral: '1013', Hex: 'E9E5CE'},
          {Id: '248', Label: 'Gold', Ral: '1006', Hex: 'E1A100'},
          {Id: '262', Label: 'Eggshell', Ral: '1015', Hex: 'EADEBD'},
        ]; const pColors = [
          {Id: '234', Label: 'Purple*', Ral: '4005', Hex: '83639D'},
          {Id: '242', Label: 'Yellow', Ral: '1012', Hex: 'D9C022'},
          {Id: '244', Label: 'Turquoise', Ral: '5018', Hex: '21888F'},
          {Id: '251', Label: 'Orange*', Ral: '2011', Hex: 'F3752C'},
          {Id: '261', Label: 'Blue Grey', Ral: '5014', Hex: '9EA0A1'},
          {Id: '275', Label: 'Primary Red', Ral: '3017', Hex: 'CB555D'},
        ];

        window.availableColors = {
          Path: 'perma-play/',
          Colors: [
            {
              Label: 'Standard Colors',
              Colors: sColors,
            },
            {
              Label: 'Standard Plus Colors',
              Colors: sPlusColors,
            },
            {
              Label: 'Premium Colors',
              Colors: pColors,
            },
          ],
        };
      } else if ( $( '.color-blend-visualizer' ).attr( 'data-type' ) == 'mulch' ) {
        const mColors = [
          {Id: '1', Label: 'Black', Ral: '9004', Hex: '282828'},
          {Id: '2', Label: 'Red', Ral: '3009', Hex: '703731'},
          // { Id: "3", Label: "Blue", Ral: "5021", Hex: "07737A" },
          {Id: '3', Label: 'Sandstone', Ral: '1011', Hex: 'AF8A54'},
          {Id: '4', Label: 'Green', Ral: '6010', Hex: '3E753B'},
          {Id: '5', Label: 'Brown', Ral: '8011', Hex: '5A3A29'},
        ];

        window.availableColors = {
          Path: 'perma-mulch/',
          Colors: [
            {
              Label: 'Perma Mulch',
              Colors: mColors,
            },
          ],
        };
      }

      const availableColors = window.availableColors;
      const root = $( '.color-blend-visualizer' ).attr( 'data-root' );
      const imgPath = `${root}/components/ColorBlendVisualizer/img/`;
      const colorsPath = `${imgPath}${availableColors.Path}`;
      const pad = function( n ) {
        return n < 10 ? `0${n}` : n;
      };

      const templateRender = function( props, subTemplate ) {
        return function( tok, i ) {
          const val = ( i % 2 ) ? props[tok] : tok;

          if ( Array.isArray( val ) ) {
            const array = val.map( function( item ) {
              const r = subTemplate.map( templateRender( item ) ).join( '' );
              return r;
            } );
            return array.join( ' ' );
          }
          return val;
        };
      };

      const templateRenderArray = function( target, template, subTemplate, flatten = false ) {
        const array = target.map( function( item ) {
          const r = template.map( templateRender( item, subTemplate ) ).join( '' );
          return r;
        } );

        if ( !flatten ) {
          return array;
        }

        return array.join( ' ' );
      };

      const templateParse = function( template ) {
        return $( `script[data-template="${template}"]` ).text().split( /\$\{(.+?)\}/g );
      };

      const padZero = function( str, len ) {
        len = len || 2;
        const zeros = new Array( len ).join( '0' );
        return ( zeros + str ).slice( -len );
      };

      const invertColor = function( hex, bw ) {
        if ( hex.indexOf( '#' ) === 0 ) {
          hex = hex.slice( 1 );
        }
        // convert 3-digit hex to 6-digits.
        if ( hex.length === 3 ) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        if ( hex.length !== 6 ) {
          throw new Error( 'Invalid HEX color.' );
        }
        let r = parseInt( hex.slice( 0, 2 ), 16 );
        let g = parseInt( hex.slice( 2, 4 ), 16 );
        let b = parseInt( hex.slice( 4, 6 ), 16 );
        if ( bw ) {
          // http://stackoverflow.com/a/3943023/112731
          return ( r * 0.299 + g * 0.587 + b * 0.114 ) > 186 ?
                '#000000' :
                '#FFFFFF';
        }
        // invert color components
        r = ( 255 - r ).toString( 16 );
        g = ( 255 - g ).toString( 16 );
        b = ( 255 - b ).toString( 16 );
        // pad each with zeros and return
        return '#' + padZero( r ) + padZero( g ) + padZero( b );
      };

      const availableColorsTpl = templateParse( 'available-colors' );
      const swatchTpl = templateParse( 'swatch' );
      const selectColorTpl = templateParse( 'select-color' );
      const selectColorPercentTpl = templateParse( 'select-color-percent' );
      const colorValueTpl = templateParse( 'color-value' );
      const colorDdlTpl = templateParse( 'color-ddl' );
      const colorDdlItemTpl = templateParse( 'color-ddl-item' );
      const mixs = [
        {
          Id: '0',
          Img: `${colorsPath}color1.jpg`,
          Label: '1 Color',
          Mix: [{Id: '0', Percentage: 100}],
        },
        {
          Id: '1',
          Img: `${colorsPath}color2.jpg`,
          Label: '2 Color',
          Mix: [
            {Id: '0', Percentage: 50},
            {Id: '1', Percentage: 50},
          ],
        },
        {
          Id: '2',
          Img: `${colorsPath}color3.jpg`,
          Label: '3 Color',
          Mix: [
            {Id: '0', Percentage: 34},
            {Id: '1', Percentage: 33},
            {Id: '2', Percentage: 33},
          ],
        },
        {
          Id: '3',
          Img: `${colorsPath}color4.jpg`,
          Label: '4 Color',
          Mix: [
            {Id: '0', Percentage: 25},
            {Id: '1', Percentage: 25},
            {Id: '2', Percentage: 25},
            {Id: '3', Percentage: 25},
          ],
        },
      ];

      $( '.cbv .available-colors' ).html( templateRenderArray( availableColors.Colors, availableColorsTpl, swatchTpl ) );

      $.each( $( '.swatch-id' ), function( i, v ) {
        const id = $( v );
        id.css( 'color', invertColor( id.data( 'color' ).toString(), true ) );
      } );

      const preLoadImages = function( hex ) {
        const images = [];
        for ( let i = 0; i < 29; i++ ) {
          images[i] = new Image();
          images[i].src = `${colorsPath}${hex}/${pad( i )}.png`;
        }
        const bg = new Image();
        bg.src = `${colorsPath}${hex}/bg.png`;
        images.push( bg );
      };

      $( '.cbv .select-colors' ).html( templateRenderArray( mixs, selectColorTpl, selectColorPercentTpl ) );

      $( '.cbv .select-colors .btn-plain' ).on( 'click', function( e ) {
        e.preventDefault();
        values = [];
        const mix = mixs[parseInt( $( this ).data( 'value' ) )].Mix;
        const ddl = templateRenderArray( availableColors.Colors, colorDdlTpl, colorDdlItemTpl );
        const html = templateRenderArray( mix, colorValueTpl );
        const newHtml = [];
        $.each( html, function( i, value ) {
          values.push( {Label: '', Percentage: mix[i].Percentage, Hex: '', Locked: false} );
          newHtml.push( value.replace( /\$%\{ddl\}/g, ddl.join( ' ' ) ) );
        } );
        $( '.cbv .color-values' ).html( newHtml );

        $( '.cbv .color-values .dropdown-menu li a' ).on( 'click', function( e ) {
          e.preventDefault();
          const target = parseInt( $( this ).parent().parent().data( 'target' ) );
          $( `#colorValue${target}` ).html( this.innerHTML );
          const btn = $( this );
          const group = availableColors.Colors.find( ( x ) => x.Colors.some( ( y ) => y.Id == btn.data( 'id' ) ) ).Label;
          values[target].Label = `${group}: ${btn.data( 'label' )}`;
          values[target].Hex = btn.data( 'hex' );
          values[target].Id = btn.data( 'id' );
          preLoadImages( values[target].Hex );
          $( this ).closest( '.dropdown-menu' ).removeClass( 'is-open' );
        } );

        $( document ).on( 'click', '.cbv .input-group-btn .dropdown-toggle', function() {
          const btn = this;
          const target = $( this ).attr( 'data-dropdown' );
          if ( !$( btn ).hasClass( 'is-open' ) ) {
            setTimeout( function() {
              $( btn ).next().addClass( 'is-open' );
              $( btn ).addClass( 'is-open' );
            }, 100 );
          }
        } );

        $( document ).on( 'click', function( e ) {
          if ( !$( e.target ).closest( '.dropdown-menu.is-open' ).length && !$( e.target ).closest( '.dropdown-toggle.is-open' ).length ) {
            $( '.dropdown-menu.is-open, .dropdown-toggle.is-open' ).removeClass( 'is-open' );
          }
        } );

        $( '.cbv .color-values .lock-percent' ).on( 'click', function( e ) {
          e.preventDefault();
          const target = parseInt( $( this ).data( 'target' ) );
          values[target].Locked = !values[target].Locked;
          $( `#percent${target}` ).prop( 'disabled', values[target].Locked );
        } );

        $( '.cbv .color-values input.slider' ).on( 'change', function() {
          const target = parseInt( $( this ).data( 'target' ) );
          const vals = values.filter( ( x, i ) => i != target && !x.Locked );
          if ( vals.length === 0 ) {
            this.value = values[target].Percentage;
            return;
          }
          let value = parseInt( this.value );
          let max = 100;
          $.each( values, function( i, v ) {
            if ( v.Locked ) {
              max -= v.Percentage;
            }
          } );
          if ( max < this.value ) {
            this.value = max;
            value = max;
          }
          let change = value - values[target].Percentage;
          values[target].Percentage = value;
          const index = Math.abs( change ) === change ? -1 : 1;
          const end = 0;
          do {
            $.each( vals, function( i, v ) {
              if ( change !== 0 && v.Percentage + index >= 0 && v.Percentage + index <= 100 ) {
                v.Percentage += index;
                change += index;
              }
            } );
          } while ( change !== 0 );
          $.each( values, function( i, s ) {
            $( `#percent${i}` ).val( s.Percentage );
            $( `#percentValue${i}` ).html( `${s.Percentage} %` );
          } );
        } );

        $( '.mix-tool' ).show();
      } );

      const Engine = Matter.Engine;
      const Render = Matter.Render;
      const Runner = Matter.Runner;
      const Common = Matter.Common;
      const World = Matter.World;
      const Bodies = Matter.Bodies;

      const engine = Engine.create();
      const world = engine.world;
      const height = 450;
      const width = 490;
      const infoHeight = 50;
      const size = 10;
      const offset = 55;
      const imgCount = 29;
      let values = [];
      const labelLayer = $( '#label-layer' )[0];
      const labelCtx = labelLayer.getContext( '2d' );
      const cbvStatic = {
        isStatic: true,
        render: {
          visible: 0,
          fillStyle: 'transparent',
          strokeStyle: 'transparent',
        },
      };
      const render = Render.create( {
        element: $( '.rock-canvas' )[0],
        engine: engine,
        options: {
          width: width,
          height: height + infoHeight * 2,
          background: 'transparent',
          showAngleIndicator: false,
          wireframes: false,
        },
      } );

      engine.world.gravity.y = 0;
      Render.run( render );

      // create runner
      const runner = Runner.create();
      Runner.run( runner, engine );

      Render.lookAt( render, {
        min: {x: 0, y: 0},
        max: {x: width, y: height},
      } );

      const drawLabels = function( callback = null ) {
        labelCtx.clearRect( 0, 0, width, height + infoHeight * 2 );
        if ( callback !== null ) {
          labelCtx.fillStyle = 'white';
          labelCtx.fillRect( 0, 0, labelLayer.width, labelLayer.height );
        }

        const img = new Image();
        img.onload = function() {
          const width = labelLayer.width / 2;
          const height =this.height / ( this.width / width );
          const x = width;
          labelCtx.globalAlpha = 0.5;
          labelCtx.drawImage( img, x, 430, width, height );

          labelCtx.globalAlpha = 1;
          labelCtx.fillStyle = 'black';
          labelCtx.font = '18px Arial';
          labelCtx.fillText( 'Mix Composition:', 20, 455 );
          labelCtx.font = '10px Arial';
          $.each( values, function( i, v ) {
            labelCtx.fillText( `${v.Percentage}% ${v.Label}`, 20, 475 + i * 16 );
          } );

          if ( callback !== null ) {
            callback();
          }
        };

        const logoPath = $( '.logo--nav' ).attr( 'src' );
        img.src = logoPath;
      };

      $( '#mixColors' ).on( 'click', function() {
        if ( values.length === 0 || values.find( ( x ) => x.Label === '' ) !== undefined ) {
          $( '.cbv-mix-error' ).show();
          return;
        }

        $( '.cbv-mix-error' ).hide();
        $( '#mixed-results' ).show();
        world.bodies = [];

        // these static walls will not be rendered
        World.add( world, [
          Bodies.rectangle( width / 2, -infoHeight, width, offset, cbvStatic ), // top
          Bodies.rectangle( width / 2, height - infoHeight, width, offset, cbvStatic ), // bottom
          Bodies.rectangle( width, ( height / 2 ) - infoHeight, offset, height, cbvStatic ), // right
          Bodies.rectangle( 0, ( height / 2 ) - infoHeight, offset, height, cbvStatic ), // left
          Bodies.rectangle( width / 2, - infoHeight, 1, 1, {
            isStatic: true,
            render: {
              sprite: {
                texture: `${colorsPath}${values[0].Hex}/bg.png`,
                xOffset: 0,
                yOffset: -.527,
              },
            },
          } ), // Background Image
        ] );

        const diameter = size * 2;
        const total = Math.round( ( width / diameter + 1 ) * ( height / diameter ) );
        let count = total;
        let options = [];
        $.each( values, function( i, value ) {
          const pct = value.Percentage / 100;

          let valueTotal = Math.ceil( total * pct ) + total % values.length;
          if ( count - valueTotal < 0 ) {
            valueTotal = count;
            count = 0;
          } else {
            count -= valueTotal;
          }
          for ( let i = 0; i < valueTotal; i++ ) {
            const index = pad( Math.round( Common.random( 0, imgCount ) ) );
            options.push( {
              density: 5e-6,
              frictionAir: 0,
              restitution: 0,
              friction: 1,
              mass: 0,
              angle: Common.random( 0, 360 ),
              render: {
                sprite: {
                  texture: `${colorsPath}${value.Hex}/${index}.png`,
                },
              },
            } );
          }
        } );

        options = Common.shuffle( options );

        const rocks = [];
        count = 0;
        for ( let x = 0; x < width / diameter; x++ ) {
          const yOffset = x % 2 === 1 ? -size : 0;
          for ( let y = 0; y < height / diameter; y++ ) {
            const circle = Bodies.circle( x * diameter + size, y * diameter + yOffset - infoHeight, size, options[count++] );
            rocks.push( circle );
          }
        }
        World.add( world, Common.shuffle( rocks ) );
        drawLabels();
      } );

      $( '#saveBlend' ).on( 'click', function() {
        const link = document.createElement( 'a' );
        link.download = 'color-blend.png';
        drawLabels( function() {
          labelCtx.drawImage( render.element.children[1], 0, 0 );
          try {
            link.href = labelLayer.toDataURL();
          } catch ( e ) {
            console.error( 'Error saving image: ', e );
          }
          link.click();
          drawLabels();
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'color-blend-visualizer', COMPONENT );
} )( app );
